export default {
  footer: {
    support1: {
      title: "Verified Network",
      desc: "Trusted restaurants & suppliers",
    },
    support2: {
      title: "All-in-One Platform",
      desc: "Orders, pricing & tracking",
    },
    support3: {
      title: "Dedicated Support",
      desc: "We’re here when you need us",
    },

    about:
      "MAHAL is a B2B marketplace that connects restaurants with verified suppliers for efficient, transparent, and reliable food sourcing.",

    company: "Company",
    about_link: "About MAHAL",
    how: "How It Works",
    careers: "Careers",
    contact: "Contact Us",

    platform: "Platform",
    restaurants: "For Restaurants",
    suppliers: "For Suppliers",
    marketplace: "Marketplace",
    pricing: "Pricing",

    resources: "Resources",
    blog: "Blog",
    faq: "FAQs",
    support: "Help Center",
    terms: "Terms & Privacy",

    news: "Stay Updated",
    news_desc:
      "Get product updates, platform news, and industry insights delivered to your inbox.",
    email: "Email address",

    copy: "© 2026 MAHAL. All rights reserved.",
  },
};